module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='	<div class="detail-chart">\n		<div id="lineChartDetail" class="modal-inner-detail"></div>\n		<div class="modal-dashboard-legend">\n			<div class="dashboard-legend-inner" id="detailLegend"></div>\n		</div>\n	</div>\n';
}
return __p;
};
